// extracted by mini-css-extract-plugin
export var externalLink = "_9p-0";
export var internalLinkLabel = "_9p-1";